var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stats-container"},[_c('h1',{staticClass:"stats-title"},[_vm._v("统计分析")]),_c('p',{staticClass:"stats-intro"},[_vm._v("这里将展示各项关键性能指标的统计数据和分析结果。")]),_c('div',{staticClass:"stats-content"},[_c('p',{staticClass:"placeholder-text"},[_vm._v("...")])])])
}]

export { render, staticRenderFns }